import React, { useState } from "react";
import Navbar from "@/components/shared/Navbar";
import Footer from "@/components/shared/Footer";
import Drawer from "@/components/shared/Drawer";
import Image from "next/image";
import { useTranslation } from "next-i18next";

const Layout = ({ scrollToSection, children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();
  return (
    <>
      {/* <div className="flex w-full items-center justify-between gap-[20px] bg-[#3B4879] px-mobile sm:justify-start sm:px-desktop">
        <p className="text-[14px] text-white">{t("program-conjucted")}</p>
        <div className="flex items-center gap-[40px]">
          <Image
            src="/images/neqsol.png"
            alt="neqsol.png"
            width={43}
            height={55}
          />
          <Image
            src="/images/tehsilinkisaf.png"
            alt="tehsil.png"
            width={90.8}
            height={36}
          />
        </div>
      </div> */}
      <Drawer
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        scrollToSection={scrollToSection}
      />
      <Navbar scrollToSection={scrollToSection} setIsOpen={setIsOpen} />
      {children}
      <Footer scrollToSection={scrollToSection} />
    </>
  );
};
export default Layout;
